"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
const mobx_react_1 = require("mobx-react");
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_1 = __importStar(require("react"));
require("./index.scss");
const DashboardMatchHistoryCard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardMatchHistoryCard"));
const DashboardLatestStatementsCard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardLatestStatementsCard"));
const DashboardRoyaltiesGraph_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardRoyaltiesGraph"));
const processing_1 = require("@App/api/routes/rightsholder/processing");
const contexts_1 = require("@App/contexts");
const DashboardWorksKpiCard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardWorksKpiCard"));
const DashboardContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardContentHeader"));
const DashboardKpiCard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardKpiCard"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const formatCurrency = (amount) => (amount === null || amount === void 0 ? void 0 : amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})) || '';
exports.formatCurrency = formatCurrency;
const RightsholderDashboard = () => {
    const { rightsholderStore, catalogSearchStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [earningsStatistics, setEarningsStatistics] = (0, react_1.useState)();
    const [earningsYTD, setEarningsYTD] = (0, react_1.useState)();
    const [earningsLastDist, setEarningsLastDist] = (0, react_1.useState)();
    const destroySearchCatalogWorks = () => {
        catalogSearchStore.destroyWorksRightsHolderPaginationInfo();
        catalogSearchStore.destroyCurrentPage();
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_home');
        destroySearchCatalogWorks();
        Promise.all([
            (0, processing_1.getEarningsForDistributionPeriods)(rightsholderStore.currentRightsholderId, 6),
            (0, processing_1.getEarningsYearToDate)(rightsholderStore.currentRightsholderId),
            (0, processing_1.getEarningsLastDistribution)(rightsholderStore.currentRightsholderId),
        ])
            .then((result) => {
            setEarningsStatistics(result[0].data);
            setEarningsYTD(result[1].data);
            setEarningsLastDist(result[2].data);
        })
            .catch(() => popupStore.setAlertData('Unable To Load Dashboard Data', true));
    }, []);
    const memberSummary = rightsholderStore.memberSummary;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Summary' }),
        react_1.default.createElement("div", { className: 'rightsholder-dashboard' },
            react_1.default.createElement(DashboardContentHeader_1.default, null),
            react_1.default.createElement("div", { className: 'dashboard-grid' },
                react_1.default.createElement(DashboardKpiCard_1.default, { title: 'Your amount paid last distribution', data: (0, exports.formatCurrency)(earningsLastDist === null || earningsLastDist === void 0 ? void 0 : earningsLastDist.amount), className: 'royalties-period' }),
                react_1.default.createElement(DashboardKpiCard_1.default, { title: 'Amount paid to date this year', data: (0, exports.formatCurrency)(earningsYTD === null || earningsYTD === void 0 ? void 0 : earningsYTD.amount), className: 'royalties-year' }),
                react_1.default.createElement(DashboardWorksKpiCard_1.default, { data: memberSummary.totalWorks }),
                react_1.default.createElement(DashboardKpiCard_1.default, { title: 'Your pending works', data: memberSummary.registrationInProgress.toLocaleString('en-US'), className: 'pending-works', tooltipContent: 'These are works registrations you have submitted that are waiting for review from our team.' }),
                react_1.default.createElement(DashboardMatchHistoryCard_1.default, null),
                react_1.default.createElement(DashboardRoyaltiesGraph_1.default, { data: earningsStatistics !== null && earningsStatistics !== void 0 ? earningsStatistics : [] }),
                react_1.default.createElement(DashboardLatestStatementsCard_1.default, null)))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderDashboard);
